import Zenscroll from 'zenscroll';

import Navigation from './components/Navigation';
import Events from './components/Events';
import Map from './components/Map';

import { GOOGLE_MAPS_API_KEY } from './config.js';

Zenscroll.setup(null, 0);

export default class App {
    constructor(el, options) {
        this.views = {};

        const $nav = document.getElementsByTagName('nav');
        this.views.navigation = new Navigation($nav[0], {});

        const $events = document.querySelectorAll('article.events')[0];

        if ($events) {
            this.views.events = new Events($events, {});
        }

        const $map = document.querySelectorAll('article.map')[0];
        if ($map) {
            this.views.map = new Map($map);
        }


        this.bindEventListener();
    }

    bindEventListener() {
        const $headerImage = document.querySelectorAll('body > header > img')[0];
        $headerImage.addEventListener('click', (e) => {
            Zenscroll.to(document.getElementsByTagName('nav')[0]);
        });

        document.querySelector('.data-link').addEventListener('click', () => {
            document.querySelector('.data-content').classList.toggle('show');
        });
    }
}



// WEBPACK FOOTER //
// ./source/_assets/js/App.js